import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import cookie from 'react-cookies';

// 路由守卫
const PrivateRoute = ({ component: Component, ...props }) => {
  const token = cookie.load('token') || '';

  return <Route {...props} render={(props) => {

    if (token) {
      return <Component />
    } else {
      // 重定向
      return <Component />
      // return <Redirect to={{
      //   pathname: '/logo',
      //   state: {
      //     // 来源
      //     from: props.location.pathname
      //   }
      // }} />
    }
  }} />
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
